import React, { useContext, useState } from "react";
import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";
import { OutlineShieldIcon } from "../../helper/svgHelper";

const InsuranceAwaitingPaymentCard = ({
  propertyId,
  recipientEmail,
  initiatedAt,
  expiresAt,
  onCancelled,
}) => {
  const { _t } = useTranslator();
  const {
    resendInsuranceBeneficiaryPaymentLink,
    cancelInsuranceBeneficiaryPayment,
  } = useContext(LandLordContext);
  const [resendLoading, setResendLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [linkSent, setLinkSent] = useState(false);

  const handleResend = async () => {
    setResendLoading(true);
    try {
      await resendInsuranceBeneficiaryPaymentLink(propertyId);
      toast.success(_t("paymentLinkResentSuccessfully"));
      setLinkSent(true);
    } catch (err) {
      toast.error(_t("errorResendingPaymentLink"));
    } finally {
      setResendLoading(false);
    }
  };

  const handleCancel = async () => {
    setCancelLoading(true);
    try {
      await cancelInsuranceBeneficiaryPayment(propertyId);
      await onCancelled?.();
    } catch (err) {
      toast.error(_t("errorCancellingInsurancePayment"));
    } finally {
      setCancelLoading(false);
    }
  };

  return (
    <div className="ib-await-banner">
      <div className="ib-await-row">
        <div className="ib-await-left">
          <div className="ib-await-icon">
            <OutlineShieldIcon size={18} color="#505b5b" />
          </div>
          <div className="ib-await-text">
            <span className="ib-await-title">
              {_t("nonPaymentInsurance")} · {_t("awaitingPayment")}
            </span>
            <span className="ib-await-sub">
              {_t("paymentLinkSentTo")} {recipientEmail || "-"}{" "}
              {_t("paymentLinkSentOn")}{" "}
              {moment(initiatedAt).format("DD MMM, HH:mm")}.{" "}
              {_t("paymentLinkExpiresAt")}{" "}
              {moment(expiresAt).format("DD MMM, HH:mm")}.{" "}
              {_t("propertyAwardedOncePaid")}
            </span>
          </div>
        </div>
        <div className="ib-await-actions">
          <button
            className={`ib-await-resend-btn ${linkSent ? "ib-await-resend-btn--sent" : ""}`}
            type="button"
            disabled={resendLoading || cancelLoading || linkSent}
            onClick={handleResend}
          >
            {resendLoading
              ? `${_t("sending")}...`
              : linkSent
                ? _t("linkSent")
                : _t("resend")}
          </button>
          <button
            className="ib-await-cancel-btn"
            type="button"
            disabled={cancelLoading || resendLoading}
            onClick={handleCancel}
          >
            {cancelLoading ? _t("cancelling") : _t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsuranceAwaitingPaymentCard;
